<template>
  <div>
    <NavbarPublicAgahi />

    <div class="page-wrapper full-page" style="margin-top: 72px">
      <div
        class="page-content d-flex justify-content-between"
        style="max-width: 1440px; margin: auto"
      >
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavbarPublicAgahi from "@/components/public/NavbarPublicAgahi.vue";
import { checkAuthUser } from "@/utils/checkAuth";

export default {
  components: {
    NavbarPublicAgahi,
  },
  data() {
    return {
      userAgent: {},
      isMenuOpen: false,
      // category: [],
      // category2: [],
      // category3: [],

      // tagsMain: [],
    };
  },

  async created() {
    await this.checkAreaAccess();

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    sleep: function (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    handleResize() {
      this.userAgent = this.$root.getUserAgentDetails();
    },
    async checkAreaAccess() {
      this.$store.commit("readUserToken");
      if (this.$store.state.userToken) {
        const authResponse = await checkAuthUser(
          "/v2/users/auth/validate",
          this.$store.state.userToken
        );

        this.sleep(100).then(() => {
          if (authResponse.status) {
            this.$store.state.userDetails = authResponse.data;
            this.$store.commit("setUserToken", this.$store.state.userToken);
            const redirect = this.$route.query.redirect;
            if (redirect) {
            } else {
            }
          } else {
            this.$store.commit("clearUserToken");
          }
        });
      } else {
        this.$store.commit("clearUserToken");
      }
    },

    // removeQueryParam(key) {
    //   const params = new URLSearchParams(window.location.search);
    //   params.delete(key);
    //   const newUrl = `${window.location.pathname}${
    //     params.toString() ? "?" + params.toString() : ""
    //   }`;
    //   window.history.replaceState({}, "", newUrl);
    // },

    // apiCallGetAgahiCategory() {
    //   this.showLoading2 = true;
    //   const url = "/public/agahi-category";
    //   const config = {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   };
    //   axios
    //     .get(url, config)
    //     .then((response) => {
    //       this.showLoading2 = false;
    //       const serverRespone = response.data;
    //       this.category = serverRespone.data;
    //     })
    //     .catch((error) => {});
    // },

    // changeCategory(name) {
    //   this.category.map((item) => {
    //     if (item.name == name) {
    //       this.category2 = item.sub;
    //       this.category3 = [];
    //     }
    //   });
    //   this.tagsMain = [];

    //   this.removeQueryParam("c2");
    //   this.removeQueryParam("c3");
    //   let params = new URLSearchParams(window.location.search);
    //   params.set("c1", name);

    //   let newUrl = `${window.location.pathname}?${params.toString()}`;
    //   window.history.pushState({}, "", newUrl);
    // },

    // changeCategory2(name) {
    //   this.category2.map((item) => {
    //     if (item.name == name) {
    //       this.category3 = item.sub;
    //     }
    //   });
    //   this.category2 = this.category2.filter((item) => item.name == name);
    //   this.tagsMain = [];
    //   const params = new URLSearchParams(window.location.search);
    //   params.set("c2", name);

    //   const newUrl = `${window.location.pathname}?${params.toString()}`;
    //   window.history.pushState({}, "", newUrl);
    // },

    // changeCategory3(name) {
    //   this.category3.map((item) => {
    //     if (item.name == name) {
    //       this.tagsMain = item.tagsMain;

    //       console.log(this.tagsMain);
    //     }
    //   });

    //   const params = new URLSearchParams(window.location.search);
    //   params.set("c3", name);

    //   const newUrl = `${window.location.pathname}?${params.toString()}`;
    //   window.history.pushState({}, "", newUrl);
    // },
  },

  mounted() {
    this.handleResize();
    // this.apiCallGetAgahiCategory();
  },
};
</script>


<style scoped>
</style>